import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import Breadcrumb from "../common/breadcrumb";
import ReactPaginate from "react-paginate";
import backend from "../../api";

const Notifications = () => {
  const { user } = useSelector((state) => state.auth);
  const [notificationsData, setNotificationsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (user) {
        setLoading(true);
        try {
          const response = await backend.get("/notifications", {
            params: { notified_user: user.user._id, page, limit: 10 },
          });
          const data = response.data;
          setNotificationsData(data.data || []);
          setTotalPages(data.totalPages || 0);
        } catch (error) {
          console.error("Error fetching notifications:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchNotifications();
  }, [user, page]);

  const handlePageChange = (selectedPage) => {
    setPage(selectedPage.selected + 1);
  };

  return (
    <div>
      <Helmet>
        <title>Eksplode | Notification Page</title>
      </Helmet>
      <Breadcrumb title={"Notification Page"} />
      {loading ? (
        <div className="dashboard">
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ClipLoader color={"#000000"} loading={loading} size={60} />
            </div>
          </div>
        </div>
      ) : notificationsData && notificationsData.length > 0 ? (
        <>
          <section className="cart-section">
            <div className="container">
              <div className="row">
                <div className="col-sm-10">
                  <table className="table cart-table table-responsive-xs">
                    <thead>
                      <tr className="table-head">
                        <th scope="col">Reminder</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col">Date/Time</th>
                      </tr>
                    </thead>
                    {notificationsData.map((item, index) => (
                      <tbody key={index}>
                        <tr>
                          <td className="col-xs-3 text-left">
                            <h5>{item.notification_message}</h5>
                          </td>
                          <td>
                            <div className="col-xs-3">
                              <h5 className="td-color">
                                {/* Placeholder for additional content */}
                              </h5>
                            </div>
                          </td>
                          <td>
                            <div className="col-xs-3">
                              <h5 className="td-color">
                                {/* Placeholder for additional content */}
                              </h5>
                            </div>
                          </td>
                          <td className="text-left">
                            {new Date(item.notification_date).toLocaleString()}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          </section>
          {/* Pagination Component */}
          <div className="d-flex justify-content-center mt-4 mb-4">
            <ReactPaginate
              previousLabel={"<<"}
              nextLabel={">>"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={page - 1}
            />
          </div>
        </>
      ) : (
        <section className="cart-section section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="col-sm-12 empty-cart-cls text-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/notify.png`}
                      className="img-fluid mb-4"
                      alt=""
                    />
                    <h3>
                      <strong>No Notifications yet!</strong>
                    </h3>
                    <h4>
                      Stay tuned! Notifications about your activity will show up
                      here
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Notifications;
